"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function SvgTicketSolid(props) {
  return React.createElement("svg", (0, _extends2.default)({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    preserveAspectRatio: "xMidYMid meet",
    stroke: props.stroke,
    fill: props.fill
  }, props), React.createElement("path", {
    d: "M23.234 4c.423 0 .766.343.766.766V7.83c0 .351-.24.658-.58.743-2.413.603-3.505 1.695-3.505 3.342s1.092 2.739 3.505 3.342c.34.085.58.392.58.743v4.085a.766.766 0 01-.766.766H.766A.766.766 0 010 20.085V16c0-.351.24-.658.58-.743 2.413-.603 3.505-1.695 3.505-3.342S2.993 9.176.58 8.573A.766.766 0 010 7.83V4.766C0 4.343.343 4 .766 4zm-9.191 4.085a.766.766 0 00-.766.766V16l.007.104A.766.766 0 0014.809 16V8.851l-.007-.104a.766.766 0 00-.76-.662z",
    fill: "inherit",
    fillRule: "evenodd"
  }));
}

var _default = SvgTicketSolid;
exports.default = _default;